// extracted by mini-css-extract-plugin
var _1 = "formatted-input__c4TN_";
var _2 = "label-auto-complete__DMbwa";
var _3 = "suggestions__jRaPr";
var _4 = "suggestions-footer__mnAi3";
var _5 = "textarea-count__LX6hz";
var _6 = "textfield__Vgbw5";
export { _1 as "formatted-input", _2 as "label-auto-complete", _3 as "suggestions", _4 as "suggestions-footer", _5 as "textarea-count", _6 as "textfield" }
